/**
 * 受注一覧 予約登録
 */
 import Vue from 'vue'
import * as httpConst from '../../../../../../constants/httpConst'
import orders_accepts_collection_registration from "./registration";

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/accepts/collections/reservations`

 const orders_accepts_collection_reservation = {
  namespaced: true,
  actions: {
    /**
     * 予約登録登録
     * @param commit
     * @param params
     * @return {Promise<unknown>}
     */
    update ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.put(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
 }

 export default orders_accepts_collection_reservation
